import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult} from '../../../shared/model/Index';
import { ITransferHistory } from '../model/transferhistory';
import { Guid } from 'guid-typescript';
import { ISportSeasonResult } from '@app/modules/search/model/studentSearchResult';
import { ISportSeasonValidation } from '../model/sportseasonvalidation';


@Injectable({ providedIn: 'root' })

export class TransferHistoryService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    get(studentId:Guid) {
        return this.http.get<ApiResult<ISportSeasonResult[]>>(env.apiUrl + 'TransferHistory/Get/' + studentId).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    
    getTransferHistoryById(id:Guid) {
        return this.http.get<ApiResult<ITransferHistory>>(env.apiUrl + 'TransferHistory/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    post(transferHistory: ITransferHistory) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'TransferHistory', transferHistory);
    }
    put(transferHistory: ITransferHistory) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'TransferHistory', transferHistory);
    }
    delete(id:Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'TransferHistory/'+id);
    }
}